<template>
	<section
		class="relative flex flex-col overflow-hidden rounded-3xl"
		:style="{
			backgroundImage: `url('/img/knowledge-base-pattern.png')`,
			backgroundSize: '400px 400px',
			backgroundRepeat: 'repeat'
		}"
	>
		<div
			class="text-white z-[1] flex flex-col bg-gradient-to-r from-primary/90 to-primary-dark/90 px-4 pb-20 pt-[76px]"
		>
			<div class="container w-full self-center">
				<div class="mx-auto max-w-4xl text-center">
					<h1 class="mb-6 text-3xl font-bold md:text-4xl lg:text-5xl">
						{{ $t("help_section_title") }}
					</h1>
					<p class="mb-8 text-xl text-white/90 md:text-2xl">
						{{ $t("help_section_subtitle") }}
					</p>

					<!-- Search Bar -->
					<div class="mx-auto max-w-2xl">
						<form class="relative" @submit.prevent="search">
							<input
								v-model="state.searchText"
								type="text"
								:placeholder="$t('search_helps')"
								class="text-slate-900 w-full rounded-2xl border-0 py-4 pe-28 ps-14 text-lg shadow-2xl focus:outline-none focus:ring-4 focus:ring-white/50"
							/>
							<Icon
								name="mdi:magnify"
								class="text-slate-400 absolute start-5 top-1/2 h-6 w-6 -translate-y-1/2"
							/>
							<button
								type="submit"
								class="text-white absolute end-2 top-1/2 -translate-y-1/2 rounded-xl bg-primary px-6 py-2 font-semibold transition-all hover:bg-primary-dark"
							>
								{{ $t("search") }}
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
const app = useNuxtApp()
const route = useRoute()

const state = reactive({
	searchText: ""
})

const qSearchText = computed(() => String(route.query.s || ""))

watch(
	qSearchText,
	() => {
		state.searchText = qSearchText.value
	},
	{
		immediate: true
	}
)

const search = () => {
	app.$router.replace({
		query: {
			s: state.searchText || undefined
		}
	})
}
</script>
